<template>
  <div class="modal-backdrop">
    <div class="popup-content">
      <button
          type="button"
          class="feedback-close-button"
          :disabled="isSaving"
          aria-label="Закрыть окно"
          @click="skipFeedback"
      >
        <span class="feedback-close-icon" aria-hidden="true"></span>
      </button>
      <form @submit.prevent="submitFeedback" class="feedback_form">
        <p class="main_header">Оцените результаты выполненной задачи</p>
        <div class="feedback-task-info">
          <div class="task-detail-time"> {{ record.is_today_expected ? 'Сегодня' :  record.date.split('-').reverse().join('.') }} {{ record.interval }}</div>
          <div>
            {{record.task.name}}
          </div>
        </div>
        <div class="form_wrapper">
          <div class="select_wrapper">
            <p class="question_label">
              Насколько успешно выполнена задача?
            </p>

            <div class="radio_group">
              <label
                  v-for="value in rateOptions"
                  :key="`successful-${value}`"
                  class="radio_option"
              >
                <input
                    v-model="form.successful_rate"
                    :value="value"
                    :disabled="isSaving"
                    type="radio"
                    name="successful_rate"
                />
                <span class="radio_text">{{ value }}</span>
                <span class="radio_circle"></span>
              </label>
            </div>
          </div>

          <div class="select_wrapper">
            <p class="question_label">
              Насколько эффективно вы применили силу эмоции?
            </p>

            <div class="radio_group">
              <label
                  v-for="value in rateOptions"
                  :key="`effective-${value}`"
                  class="radio_option"
              >
                <input
                    v-model="form.effective_rate"
                    :value="value"
                    :disabled="isSaving"
                    type="radio"
                    name="effective_rate"
                />
                <span class="radio_text">{{ value }}</span>
                <span class="radio_circle"></span>
              </label>
            </div>
          </div>

          <custom-textarea
              :disabled="isSaving"
              :label="'Комментарий'"
              :labelWidth="28"
              v-model="form.comment"
              name="trigger_list"
          />
        </div>

        <button type="submit" class="btn btn-accent mr-10" :disabled="isSaving">
          Сохранить
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import CustomTextarea from "@/components/Forms/Fields/CustomTextarea.vue";
import { notify } from "@kyvg/vue3-notification";
import { message } from "ant-design-vue";

export default {
  name: "PopUpTrackerFeedback",
  components: { CustomTextarea },
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  setup(props, context) {
    const store = useStore();
    const isSaving = ref(false);
    const rateOptions = [1, 2, 3, 4, 5];

    const form = reactive({
      successful_rate: null,
      effective_rate: null,
      comment: null,
    });

    const submitFeedback = () => {
      if (!form.successful_rate || !form.effective_rate) {
        notify({
          title: "Не все поля заполнены",
          text: "Пожалуйста, оцените успешность выполнения задачи и эффективность использования эмоций",
          type: "warning",
        });
        return;
      }

      isSaving.value = true;

      store.dispatch("tracker/submitFeedback", {
        id: props.record.occurred_task_id,
        form: { ...form },
      })
          .then(() => {
            message.info("Запись сохранена");
            context.emit("close");
          })
          .finally(() => {
            isSaving.value = false;
          });
    };

    const skipFeedback = () => {
      isSaving.value = true;

      store.dispatch("tracker/submitFeedback", {
        id: props.record.occurred_task_id,
        form: {
          ...form,
          feedback_skipped: true,
        },
      })
          .then(() => {
            context.emit("close");
          })
          .finally(() => {
            isSaving.value = false;
          });
    };

    return {
      isSaving,
      form,
      rateOptions,
      submitFeedback,
      skipFeedback,
    };
  },
};
</script>

<style scoped lang="scss">
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content {
  position: relative;
  display: flex;
  padding: 20px;
  width: 600px;
  min-height: 450px;
  background-color: white;
  border-radius: 6px;

  @media (max-width: 1024px) {
    width: 90%;
  }
}

.feedback-close-button {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, opacity 0.2s ease;
}

.feedback-close-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.feedback-close-icon {
  position: relative;
  width: 16px;
  height: 16px;
}

.feedback-close-icon::before,
.feedback-close-icon::after {
  content: "";
  position: absolute;
  top: 7px;
  left: 0;
  width: 16px;
  height: 2px;
  border-radius: 2px;
  background-color: #333;
}

.feedback-close-icon::before {
  transform: rotate(45deg);
}

.feedback-close-icon::after {
  transform: rotate(-45deg);
}

.feedback_form {
  display: flex;
  margin: auto;
  align-items: center;
  flex-direction: column;
  row-gap: 15px;
  width: 100%;

  .btn-accent {
    margin-left: auto;
    font-weight: bold;
    border-radius: 16px;
  }

  :deep(.custom-input) {
    border-radius: 6px;
  }
}

.form_wrapper {
  width: 100%;
}

.main_header {
  margin: 10px 42px 10px 0;
  font-weight: bold;
}

.select_wrapper {
  margin: 14px 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;

  @media (max-width: 768px) {
    row-gap: 12px;
  }
}

.question_label {
  font-size: 16px;
  margin: 0;
  flex: 1;
}

.radio_group {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  flex-wrap: wrap;
}

.radio_option {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  cursor: pointer;
  min-width: 42px;
  user-select: none;
  transition: 0.2s ease;
}

.radio_option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.radio_text {
  font-size: 13px;
  font-weight: 600;
  color: #4f4f4f;
  line-height: 1;
  pointer-events: none;
}

.radio_circle {
  width: 22px;
  height: 22px;
  border: 2px solid #bdbdbd;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  background: #fff;
}

.radio_option:hover .radio_circle {
  border-color: var(--main-color);
}

.radio_option input:checked ~ .radio_circle {
  border-color: var(--main-color);
}

.radio_option input:checked ~ .radio_circle::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background: var(--main-color);
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.radio_option input:disabled ~ .radio_circle {
  background: #f3f3f3;
  cursor: not-allowed;
}

.radio_option input:disabled ~ .radio_text {
  opacity: 0.7;
}

.radio_option:has(input:disabled) {
  cursor: not-allowed;
  opacity: 0.7;
}

.feedback-task-info {
  align-self: flex-start;
}
</style>
